import "./css/styles.css";
import { Route, Switch, Link, useLocation, useHistory } from "react-router-dom";
import Home from "./components/Home";
import Contact from "./components/Contact";
import Projects from "./components/Projects";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import { useEffect, useState } from "react";

function App() {
  const [contact, setContact] = useState(true);
  const toggleContact = () => {
    setContact(!contact);
  };
  const [locationKeys, setLocationKeys] = useState([]);
  const history = useHistory();

  useEffect(() => {
    return history.listen((location) => {
      if (history.action === "PUSH") {
        setLocationKeys([location.key]);
      }

      if (history.action === "POP") {
        if (locationKeys[1] === location.key) {
          setLocationKeys(([_, ...keys]) => keys);
          // Handle forward event
        } else {
          setLocationKeys((keys) => [location.key, ...keys]);
          setContact(true);
          // Handle back event
        }
      }
    }); // eslint-disable-next-line
  }, [locationKeys]);
  const location = useLocation();
  return (
    <TransitionGroup>
      <CSSTransition timeout={500} classNames="fade" key={location.key}>
        <div className="App">
          <header className="home-pic-container">
            <nav>
              <Link className="txt-dec" to="/contact">
                {contact ? (
                  <h4 onClick={toggleContact} className="link">
                    Contact
                  </h4>
                ) : null}
              </Link>
              <h2>Matthew Casey</h2>
            </nav>
      <div className="social-link-wrapper">
        <a
          href="https://www.facebook.com/matthew.casey.714/"
          target="_blank"
          rel="noreferrer"
        >
          <img
            className="social-links"
            src="http://halfwheel.com/wp-content/uploads/2016/04/facebook-logo-blue-background.jpg"
            alt="fb-icon"
          />
        </a>
        <a
          href="https://www.linkedin.com/in/matthew-casey-8403b9210/"
          target="_blank"
          rel="noreferrer"
        >
          <img
            className="social-links"
            src="https://icon-library.com/images/official-linkedin-icon-png/official-linkedin-icon-png-16.jpg"
            alt="linkedin-icon"
          />
        </a>
        <a
          href="https://github.com/mattcasey879"
          target="_blank"
          rel="noreferrer"
        >
          <img
            className="social-links"
            src="https://icon-library.com/images/icon-github/icon-github-11.jpg"
            alt="github-icon"
          />
        </a>
      </div>
          </header>
          <Switch location={location}>
            <Route path="/projects">
              <Projects />
            </Route>
            <Route path="/contact">
              <Contact toggleContact={toggleContact} />
            </Route>
            <Route path="/">
              <Home />
            </Route>
          </Switch>

          <footer>
            <p id="copy-footer">&copy; matthew-casey 2021</p>
          </footer>
        </div>
      </CSSTransition>
    </TransitionGroup>
  );
}

export default App;
